import * as Scrivito from "scrivito";

const widgetAreaOptions = [
  "widgetlist",
  {
    only: ["TextFooterWidget", "LinksFooterWidget", "ImageFooterWidget"],
  },
];

const FooterContainerWidget = Scrivito.provideWidgetClass(
  "FooterContainerWidget",
  {
    attributes: {
      headline: "string",
      widgetarea_1: widgetAreaOptions,
      widgetarea_2: widgetAreaOptions,
      widgetarea_3: widgetAreaOptions,
      widgetarea_4: widgetAreaOptions,
      columnAmount: ["enum", { values: ["1", "2", "3", "4"] }],
    },
    extractTextAttributes: ["headline"],
  },
);

export default FooterContainerWidget;
